import React from "react";

import { BoxBasedComponentProps } from "../Box";
import { Link } from "../Link";
import { Flex } from "../Flex";
import { Icon } from "../Icon";
import Text from "components/text";
import { AvatarImg, LogoImg } from "../Image";

export type OwnerHeaderBaseProps = BoxBasedComponentProps<
  "div",
  {
    agencyId: string;
    avatarUrl: string | undefined;
    description: string | undefined;
    logoUrl: string | undefined;
    isOwned: boolean;
    ownerType: string;
  }
>;

export const OwnerHeaderBase = ({
  agencyId,
  avatarUrl,
  description,
  logoUrl,
  isOwned,
  ownerType,
  children,
  ...props
}: OwnerHeaderBaseProps) => {
  const verified = isVerifiedType(ownerType, isOwned);

  return (
    <Flex
      alignItems={"center"}
      justifyContent={"space-between"}
      {...props}
      width={"100%"}
    >
      <Flex {...props} alignItems={"center"} textStyle={"body-normal-medium"}>
        {avatarUrl && (
          <Link
            href={`/agencies/${agencyId}`}
            target={"_blank"}
            rel={"noopener noreferrer"}
            height={"44px"}
          >
            <AvatarImg
              src={avatarUrl}
              onClick={() => window.open(`/agencies/${agencyId}`)}
              onError={e => {
                (e.currentTarget as HTMLImageElement).style.display = "none";
              }}
            />
          </Link>
        )}
        {avatarUrl === undefined && verified && (
          <Icon name={"verified"} size={20} color={"#0074C2"} mr={1} mb={0} />
        )}
        <Flex flexDirection={"column"} ml={avatarUrl ? 2 : 0}>
          <Flex alignItems={"center"} color={"#0074C2"}>
            {avatarUrl !== undefined && verified && (
              <Icon
                name={"verified"}
                size={16}
                color={"#0074C2"}
                mr={1}
                mb={0}
              />
            )}
            {children}
          </Flex>
          {description && (
            <Link
              href={`/agencies/${agencyId}`}
              target={"_blank"}
              rel={"noopener noreferrer"}
            >
              <Text
                fontWeight={100}
                fontSize={13}
                lineHeight={1}
                color={"#6E6E6E"}
              >
                {description}
              </Text>
            </Link>
          )}
        </Flex>
      </Flex>
      {logoUrl && (
        <Flex alignItems={"flex-end"} mr={3} data-testid={"x-logo"}>
          <LogoImg src={logoUrl} />
        </Flex>
      )}
    </Flex>
  );
};

const isVerifiedType = (type: string | null | undefined, isOwned: boolean) => {
  return type !== "neighbor" || isOwned;
};
